module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_7016.24cb7933.png";